import { useLoaderData } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { Container, Lightbox } from '@dma/ui';
import type { GalleryViewDto } from '../application/dto/GalleryDto';
import { GalleryGrid } from './GalleryGrid';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './GalleryPage.css';

export function GalleryPage() {
  const { albums, items } = useLoaderData() as GalleryViewDto;
  useDocumentHead(staticSeo.gallery);
  const [activeAlbumId, setActiveAlbumId] = useState<string | null>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const visibleItems = useMemo(
    () => (activeAlbumId ? items.filter((item) => item.albumId === activeAlbumId) : items),
    [items, activeAlbumId]
  );

  const activeItem = openIndex !== null ? visibleItems[openIndex] : null;

  return (
    <Container>
      <section className="dma-gallery-page">
        <h1>گالری تصاویر و ویدیو</h1>

        {albums.length > 0 ? (
          <div className="dma-gallery-page__filters">
            <button
              type="button"
              className={activeAlbumId === null ? 'dma-gallery-page__filter--active' : ''}
              onClick={() => setActiveAlbumId(null)}
            >
              همه
            </button>
            {albums.map((album) => (
              <button
                key={album.id}
                type="button"
                className={activeAlbumId === album.id ? 'dma-gallery-page__filter--active' : ''}
                onClick={() => setActiveAlbumId(album.id)}
              >
                {album.title}
              </button>
            ))}
          </div>
        ) : null}

        <GalleryGrid items={visibleItems} onItemClick={setOpenIndex} />
      </section>

      {activeItem ? (
        <Lightbox
          item={{ type: activeItem.type, url: activeItem.url, caption: activeItem.caption }}
          onClose={() => setOpenIndex(null)}
          onNext={
            openIndex !== null && openIndex < visibleItems.length - 1
              ? () => setOpenIndex(openIndex + 1)
              : undefined
          }
          onPrevious={openIndex !== null && openIndex > 0 ? () => setOpenIndex(openIndex - 1) : undefined}
        />
      ) : null}
    </Container>
  );
}
